// extracted by mini-css-extract-plugin
module.exports = {"twitter":"Twitter-module--twitter--DqvMy"};